module.exports = __webpack_public_path__ + "static/media/fr.f8952213.svg";